import { useChainId } from 'wagmi'
import { LotteryRound } from '@/types/lottery'
import { useEffect, useState } from 'react'
import { useBlockPotEvents } from '@/providers/BlockPotEventsProvider'
import useLotteryRead from '../read/useLotteryRead'
import { calculateMaxRoundsInPot } from './useMaxRoundsInPot'

export default function useRoundDraw(chainChanged: boolean, drawnRoundIndexOverride?: number) {
    const [drawnRoundOpened, setDrawnRoundOpened] = useState(false)
    const chainId = useChainId()
    const [drawnRound, setDrawnRound] = useState<LotteryRound | undefined>()
    const [roundIndex, setRoundIndex] = useState<number>(-1)
    const [lastDrawnRoundIndex, setLastDrawnRoundIndex] = useState<number>(-1)
    const { game, selectedGame } = useLotteryRead()

    const { lotteryRoundBlockNumber } = useBlockPotEvents()
    
    useEffect(() => {
        if (chainChanged) {
            setRoundIndex(-1)
            setLastDrawnRoundIndex(-1)
        }
    }, [chainChanged])

    useEffect(() => {
        setRoundIndex(-1)
        setLastDrawnRoundIndex(-1)
    }, [selectedGame])

    useEffect(() => {
        const loadCurrentRoundId = async () => {
            const roundIndex = await game.currentRoundIndex()
            setRoundIndex(roundIndex)
        }
        loadCurrentRoundId()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lotteryRoundBlockNumber, chainId])

    useEffect(() => {
        const loadCurrentRoundId = async () => {
            const roundIndex = await game.currentRoundIndex()
            setRoundIndex(roundIndex)
            setLastDrawnRoundIndex(roundIndex)
        }
        if (roundIndex == -1) {
            loadCurrentRoundId()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGame, roundIndex])

    useEffect(() => {
        const loadDrawnRound = async (roundIndex: number) => {
            const roundData = await game.getRoundData([roundIndex])
            const maxRoundsInPot = calculateMaxRoundsInPot(await game.currentGameConfig()) ?? 0 // TODO: This needs to be stored on chain
            
            setDrawnRound({
                roundIndex,
                draws: roundData.draws,
                entryCount: roundData.entryCount,
                prizePool: roundData.prizePool,
                drawTime: roundData.drawTime,
                chance: roundData.chance,
                done: roundData.status === 2, // 2 = DONE // TODO: Perhaps we need to handle all enum states??
                potIndex: roundData.potIndex,
                roundIndexInPot: roundData.roundIndexInPot,
                maxRoundsInPot
            })
        }
        if (drawnRoundIndexOverride) {
            loadDrawnRound(drawnRoundIndexOverride)
            return
        }
        if (roundIndex === -1 || lastDrawnRoundIndex === -1) {
            return
        }
        if (roundIndex !== lastDrawnRoundIndex) {
            loadDrawnRound(lastDrawnRoundIndex)
            setLastDrawnRoundIndex(roundIndex)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGame, lastDrawnRoundIndex, roundIndex, drawnRoundIndexOverride])

    return {
        roundIndex,
        drawnRound,
        clearDrawnRound: () => { setDrawnRound(undefined) },
        drawnRoundOpened,
        setDrawnRoundOpened
    }
}